import FusePageCarded from '@fuse/core/FusePageCarded';
import { makeStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import FuseLoading from '@fuse/core/FuseLoading';
import { useDispatch } from 'react-redux';
import useToast from '@fuse/hooks/useToast';
import withReducer from 'app/store/withReducer';
import reducer from '../store';
import SalesOrderTable from './tables';
import SaveReportDialog from './saveReportDialog';

const useStyles = makeStyles({
	layoutRoot: {
		background:'#fcfcfc'
	},
	pullRight:{
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "flex-end"
	},
	buttonContainer:{
		display: 'flex',
		flexDirection: 'row'
	},
	buttonSquare:{
		borderRadius: '5px'
	},
	topBg:{
		background:'#fcfcfc'
	},
	contentCard:{
		marginBottom:"15px",
		borderRadius:"5px"
	}
});



function CardedFullWidth2TabbedSample(props) {
	const classes = useStyles();
	const [loading, setLoading] = useState(false);
	const [selectedTab, setSelectedTab] = useState(0);
	const [selectedView, setSelectedView] = useState(0);
	const dispatch = useDispatch();
	const toast = useToast(dispatch);
	
	// const { hasPermission } = usePermission()

	// const viewManufacturersPermission = hasPermission('view-manufacturers')
	// const createManufacturersPermission = hasPermission('create-manufacturers')
	// const updateManufacturersPermission = hasPermission('update-manufacturers')



	

	const [platformModule, setPlatformModule] = useState({});
	const [platformModuleAttributes, setPlatformModuleAttributes] = useState([]);
	


	function callToast(success,error,value){
        if(success){
            toast.success(value)
        }
        if(error){
            toast.error(value);
        }
    }

	if(loading){
		return(<FuseLoading />)
	}
		return (<>
				<SaveReportDialog callToast = { callToast } />

				<FusePageCarded
				classes={{
					root: classes.layoutRoot,
					toolbar: 'p-0',
					topBg:classes.topBg,
					contentCard:classes.contentCard
				}}
				// header={
				// 	<DynamicFieldsHeader />
				// }
				content={
					<>
						<div className={selectedTab !== 0 ? 'hidden' : ''}>
						{
							loading && <FuseLoading />
						}
						{
							!loading && <SalesOrderTable 
							// endUsersAccounts={invoices}
							selectedView={selectedView}
							// gotoDetailsPage={gotoDetailsPage}
							// refresh={refreshList}
						/>
						}
						</div>
					</>
				}
				innerScroll
			/>
			
		</>)
	
}

export default withReducer('incidentApp', reducer)(CardedFullWidth2TabbedSample);
